"use client";

import { Moon, Sun, Laptop } from "lucide-react";
import { useTheme } from "next-themes";
import DropdownSelector from "../ui/DropdownSelector";
import { useTranslations } from "next-intl";

const modes = [
  {
    label: "darkMode_light",
    value: "light",
    icon: <Sun className="w-4 h-4" />,
  },
  {
    label: "darkMode_dark",
    value: "dark",
    icon: <Moon className="w-4 h-4" />,
  },
  {
    label: "darkMode_system",
    value: "system",
    icon: <Laptop className="w-4 h-4" />,
  },
];

export default function DarkModeSelector() {
  const { theme, setTheme } = useTheme();
  const t = useTranslations("Navbar");

  const handleSelect = (value: string) => {
    setTheme(value);
  };

  const translated = modes.map((mode) => ({
    ...mode,
    label: t(mode.label),
  }));

  return (
    <DropdownSelector
      items={translated}
      selected={theme || "system"}
      onSelect={handleSelect}
      iconOnly
      label={t("darkMode_title")}
      renderIcon={(item) => item.icon}
    />
  );
}
